// services/invoices.js
import { supabase } from '../supabase';

export const createInvoice = async (data) => {
    const { data: invoice, error } = await supabase
        .from('invoices')
        .insert([data])
        .select();

    if (error) {
        throw new Error(error.message);
    }

    return invoice ? invoice[0] : null;
};

export const getInvoicesByFileOpening = async (fileOpeningId, { limit = 10, offset = 0, sortBy = 'id', sortOrder = 'desc', searchTerm = '' }) => {
    let query = supabase
        .from('invoices')
        .select('id, client_name, address,phone,mobile, grand_total, date, status, fid', { count: 'exact' })
        .eq('fid', fileOpeningId)
        .is('deleted_at', null)
        .order(sortBy, { ascending: sortOrder === 'asc' })
        .range(offset, offset + limit - 1);

    if (searchTerm) {
        query = query.or(`invoice_number.ilike.%${searchTerm}%,status.ilike.%${searchTerm}%`);
    }

    const { data: invoices, error, count } = await query;

    if (error) {
        throw new Error(error.message);
    }

    return { invoices, count };
};

export const getInvoiceById = async (id) => {
    const { data: invoice, error } = await supabase
        .from('invoices')
        .select('*')
        .eq('id', id)
        .single();

    if (error) {
        throw new Error(error.message);
    }

    return invoice;
};

export const updateInvoice = async (id, data) => {
    const { data: invoice, error } = await supabase
        .from('invoices')
        .update(data)
        .eq('id', id);

    if (error) {
        throw new Error(error.message);
    }

    return invoice ? invoice[0] : null;
};

export const deleteInvoice = async (id) => {
    const { data, error } = await supabase
        .from('invoices')
        .update({ deleted_at: new Date() })
        .eq('id', id);

    if (error) {
        throw new Error(error.message);
    }

    return data;
};

// Optional: Get all invoices with file opening details
export const getAllInvoices = async ({ limit = 10, offset = 0, sortBy = 'id', sortOrder = 'desc', searchTerm = '' }) => {
    let query = supabase
        .from('invoices')
        .select(`
      fid,
      id, 
      amount, 
      date, 
      status,
    `, { count: 'exact' })
        .is('deleted_at', null)
        .order(sortBy, { ascending: sortOrder === 'asc' })
        .range(offset, offset + limit - 1);

    if (searchTerm) {
        query = query.or(`invoice_number.ilike.%${searchTerm}%,status.ilike.%${searchTerm}%,file_openings.forename.ilike.%${searchTerm}%,file_openings.surname.ilike.%${searchTerm}%`);
    }

    const { data: invoices, error, count } = await query;

    if (error) {
        throw new Error(error.message);
    }

    return { invoices, count };
};

// Optional: Update invoice status
export const updateInvoiceStatus = async (id, status) => {
    const { data: invoice, error } = await supabase
        .from('invoices')
        .update({ status, updated_at: new Date() })
        .eq('id', id);

    if (error) {
        throw new Error(error.message);
    }

    return invoice ? invoice[0] : null;
};